import DepartmentPage from './department.react';
import DepartmentFormPage from './department-form.react';

export {
  DepartmentPage,
  DepartmentFormPage
};



// WEBPACK FOOTER //
// ./src/department/index.js